
angular.module('unergie.main')
.controller('contractTerminationModalCtrl', (
    $rootScope, $scope, $uibModalInstance, CommonRegex, ApiUser, AdminComments, PrmUtilsService, OrganizationService,
    contract, pro, overdueOnly, DataAccessVariables, AlertManager, BoFeaturesService, ErrorCatcher, energy_check_validity, AuthService) => {
    const feats = BoFeaturesService.getModuleFeatures('contracts')
    $scope.showTerminationReason = BoFeaturesService.get('showTerminationReason')
    $scope.checkReadingForTermination = BoFeaturesService.get('checkReadingForTermination')
    $scope.isMigratedLinky = PrmUtilsService.isMigratedLinky(contract.prm) && contract.prm.teleoperable
    $scope.isCommunicatingLinky = PrmUtilsService.isLinky(contract.prm.metter_kind) && contract.prm.communicating
    $scope.isLinkyNotTeleoperable = PrmUtilsService.isMigratedLinky(contract.prm) && !contract.prm.teleoperable
    $scope.maxDays = PrmUtilsService.getMaxDaysForPRMIntervention(contract.prm)
    $scope.pro = pro
    $scope.overdueOnly = overdueOnly
    $scope.nbDigitsMask = '9?9?9?9?9?9?'
    $scope.meterType = contract.id_p_calendar || contract.prm.id_p_calendar || contract.prm.id_d_calendar || 'BASE'
    $scope.isC2C4 = ['C2', 'C3', 'C4', 'INDET_C2_C3'].includes(contract.prm.segment)

    $scope.existingTechnicalContact = contract.technicalContact && contract.technicalContact.length && contract.technicalContact[0]

    if (pro) {
        OrganizationService.handlesServiceOrders(contract.account.organization).then((handlesServiceOrders) => {
            $scope.handlesServiceOrders = handlesServiceOrders
            $scope.canBypassServiceOrder = handlesServiceOrders && BoFeaturesService.isFeatureOn('canBypassServiceOrder')
        })
    }

    $scope.canReducOutage = () => feats.canReducOutage && !pro
    $scope.canTerminateAfterRemoval = feats.canTerminateAfterRemoval
    $scope.nameRegex = CommonRegex.fullname
    $scope.phoneRegex = CommonRegex.phone.french
    $scope.emailsRegex = CommonRegex.email

    $scope.mode = 'terminate'
    $scope.selectedAction = 'terminateFromClient'
    $scope.sendOverdueValue = true

    $scope.requester = {}

    $scope.validations = {}
    $scope.comments = undefined
    $scope.handmadeRemovalCaseID = undefined

    $scope.availableHour = ['08', '09', '10', '11', '13', '14', '15', '16']
    $scope.availableMinute = ['00', '15', '30', '45']

    $scope.availability = {
        dateObject: moment().startOf('day').toDate(),
        slot: undefined,
        minDate: moment().startOf('day').toDate(),
        maxDate: moment().add($scope.maxDays, 'day').startOf('day').toDate(),
        hourOnly: $scope.availableHour[0],
        minute: $scope.availableMinute[0],
    }

    $scope.modes = [
        { value: 'terminateFromClient', label: 'Résiliation Client', disabled: false, display: !overdueOnly },
        { value: 'terminateFromUs', label: 'Résiliation Fournisseur', disabled: false, display: true },
        { value: 'suspend', label: 'Coupure', disabled: false, display: true },
        { value: 'reduce', label: 'Limitation', disabled: false, display: true },
        { value: 'restore', label: 'Restauration post-limitation', disabled: false, display: !overdueOnly },
        { value: 'reactivate', label: 'Restauration post-coupure', disabled: false, display: !overdueOnly },
    ]

    $scope.reason = {
        choice: $scope.showTerminationReason ? null : 'CLIENT',
        text: '',
    }

    $scope.getAction = () => _.find($scope.modes, { value: $scope.selectedAction }).label

    $scope.idContract = contract.id
    const initialReadings = {
        base: undefined,
        hp: undefined,
        hc: undefined,
    }

    $scope.order = {
        readingMode: 'std',
        readings: _.clone(initialReadings),
        bypassServiceOrder: false,
        isKnownSuccessor: ($scope.isC2C4 && pro) ? null : undefined,
    }
    $scope.order.origin = 'client'
    $scope.order.acceleratedProcedure = false

    $scope.overrideContact = $scope.pro && !$scope.isMigratedLinky
    $scope.contact = {
        civ: $scope.existingTechnicalContact ? $scope.existingTechnicalContact.civ : 'M.',
        givenname: $scope.existingTechnicalContact ? $scope.existingTechnicalContact.givenname : undefined,
        sn: $scope.existingTechnicalContact ? $scope.existingTechnicalContact.sn : undefined,
        phone: $scope.existingTechnicalContact ? $scope.existingTechnicalContact.phone : undefined,
    }

    let hibernationStartDate
    let hibernationEndDate
    let minDateProviderResil
    let maxDateProviderResil

    // Récuprération des dates de trève hivernale
    DataAccessVariables.get({ variables: 'HIBERNATION_END_DATE,HIBERNATION_START_DATE' }).$promise
    .then((variables) => {
        hibernationEndDate = moment(variables.HIBERNATION_END_DATE, 'DD_MM')
        // date de début dans 15 jours ou à la fin de la trève
        minDateProviderResil = moment.max(moment().add(15, 'day').startOf('day'), hibernationEndDate)

        hibernationStartDate = moment(variables.HIBERNATION_START_DATE, 'DD_MM')
        // date de fin dans $scope.maxDays jours ou au début de la trève
        maxDateProviderResil = moment.min(moment().add($scope.maxDays, 'day').startOf('day'), hibernationStartDate)

        const hibernation = moment().isBefore(hibernationEndDate) || moment().isAfter(hibernationStartDate)

        // Avec les délais il n'est pas possible de faire une coupure fournisseur
        if (minDateProviderResil > maxDateProviderResil) {
            _.find($scope.modes, ['value', 'terminateFromUs']).disabled = true
            _.find($scope.modes, ['value', 'terminateFromUs']).label = 'Résiliation Fournisseur (trève hivernale)'
        }

        // On est en période de trève hivernale : pas de coupure
        if (hibernation) {
            _.find($scope.modes, ['value', 'suspend']).disabled = true
            _.find($scope.modes, ['value', 'suspend']).label = 'Coupure (trève hivernale)'

            // On est en période de trève hivernale avec un chèque énergie : pas de limitation
            if (energy_check_validity) {
                _.find($scope.modes, ['value', 'reduce']).disabled = true
                _.find($scope.modes, ['value', 'reduce']).label = 'Limitation (chèque énergie)'
            }
        }

        if (overdueOnly) {
            $scope.mode = hibernation ? 'reduce' : 'suspend'
            $scope.selectedAction = hibernation ? 'reduce' : 'suspend'
        }
    })

    const calculateDates = (originTermination) => {
        let minDate
        let maxDate
        if (originTermination === 'us') {
            minDate = minDateProviderResil
            maxDate = maxDateProviderResil
        } else {
            minDate = moment().startOf('day')
            maxDate = moment().add($scope.maxDays, 'day').startOf('day')
        }
        $scope.availability.dateObject = minDate.toDate()
        $scope.availability.minDate = minDate.toDate()
        $scope.availability.maxDate = maxDate.toDate()
    }

    $scope.onChangeAction = () => {
        $scope.order.readings = _.clone(initialReadings)
        $scope.mode = $scope.selectedAction
        if ($scope.pro && ['terminateFromClient', 'terminateFromUs'].includes($scope.selectedAction)) {
            $scope.order.origin = 'client'
            $scope.mode = 'terminate'
            $scope.reason.choice = null
        } else if ($scope.selectedAction === 'terminateFromClient') {
            $scope.order.origin = 'client'
            $scope.mode = 'terminate'
            $scope.reason.choice = $scope.showTerminationReason ? null : 'CLIENT'
            calculateDates($scope.order.origin)
        } else if ($scope.selectedAction === 'terminateFromUs') {
            $scope.order.origin = 'us'
            $scope.mode = 'terminate'
            $scope.reason.choice = 'PROVIDER'
            if (!$scope.order.acceleratedProcedure) {
                calculateDates($scope.order.origin)
            }
        }
        if ($scope.order.origin === 'client' && !pro) {
            $scope.availability.slot = undefined
        }
        if ($scope.isC2C4 && $scope.pro) {
            if ($scope.order.origin === 'client') {
                delete $scope.order.isCustomerInformed
            }
            if ($scope.order.origin === 'us' && $scope.order.isCustomerInformed !== undefined) {
                $scope.order.isCustomerInformed = null
            }
        }
    }

    $scope.onChangeAction()

    $scope.onChoiceReasonChange = (reasonOverride) => {
        if (reasonOverride) {
            $scope.reason.choice = reasonOverride
        }
        if ($scope.reason && $scope.reason.choice === 'ASK_REMOVAL') {
            $scope.isAskRemovalChoice = true
            $scope.mode = 'askTermination'
        } else {
            $scope.isAskRemovalChoice = false
            $scope.mode = 'terminate'
        }
    }

    $scope.onChoiceReasonChange()

    $scope.showSendValue = () => ['suspend', 'reduce'].includes($scope.mode)

    // La date est proposée si on demande une résiliation et que l'on est pas dans en résil fournisseur en RIF courte
    $scope.showDate = () => ['terminate', 'askTermination', 'reduce'].includes($scope.mode) && !($scope.order.origin === 'us' && $scope.order.acceleratedProcedure)

    $scope.showUrgent = () => ['restore', 'reactivate'].includes($scope.mode)

    $scope.showContact = () => ['restore', 'reactivate', 'suspend', 'reduce', 'askTermination'].includes($scope.mode) ||
        (($scope.mode === 'terminate') && ($scope.order.origin === 'us' || (pro && !$scope.isMigratedLinky)))

    $scope.showAvailability = () => $scope.isC2C4 || ($scope.reason.choice !== 'ASK_REMOVAL' && (($scope.order.origin === 'us' && !$scope.order.acceleratedProcedure) || (pro && !$scope.isMigratedLinky)))

    $scope.mustShowInterventionHour = () => $scope.isC2C4

    $scope.showRequester = () => ($scope.pro && ['terminate'].includes($scope.mode) && $scope.handlesServiceOrders) || $scope.isAskRemovalChoice

    $scope.showCustomerInformed = () => $scope.order.isCustomerInformed !== undefined

    $scope.showKnownSuccessor = () => $scope.order.isKnownSuccessor !== undefined

    const updateContact = function (payload) {
        if ($scope.overrideContact) {
            payload.contact = {
                civ: $scope.contact.civ || undefined,
                givenname: $scope.contact.givenname || undefined,
                sn: $scope.contact.sn || undefined,
                phone: $scope.contact.phone || undefined,
            }
            if (!$scope.contact.civ || !$scope.contact.givenname || !$scope.contact.sn || !$scope.contact.phone) {
                AlertManager.error('Veuillez renseigner le téléphone, un nom et un prénom')
                return false
            }
        }
        if ($scope.showRequester() && !$scope.order.bypassServiceOrder) {
            if (!$scope.requester.requester_civ || !$scope.requester.requester_givenname || !$scope.requester.requester_sn ||
                ($scope.isAskRemovalChoice && !$scope.requester.requester_phone && !$scope.requester.requester_email)) {
                AlertManager.error('Veuillez renseigner le demandeur')
                return false
            }
            payload.requester = _.pick($scope.requester, ['requester_civ', 'requester_givenname', 'requester_sn', 'requester_phone', 'requester_email'])
        }
        return true
    }

    $scope.longFormat = (stringDate) => moment(stringDate, 'YYYY-MM-DD').format('DD MMMM YYYY')

    const parseAvailableSlots = function (result) {
        $scope.days = []
        _.forEach(result, (r) => {
            const existing = _.find($scope.days, { date: r.date })
            if (existing) {
                existing.availableSlots.push(r.code)
            } else {
                $scope.days.push({ date: r.date, availableSlots: [r.code] })
            }
        })
    }

    $scope.dateChange = () => {
        if (moment($scope.availability.dateObject).isBefore($scope.availability.minDate)) {
            $scope.availability.dateObject = $scope.availability.minDate
        } else if (moment($scope.availability.dateObject).isAfter($scope.availability.maxDate)) {
            $scope.availability.dateObject = $scope.availability.maxDate
        }
    }

    $scope.terminate = function () {
        if ($scope.processing) {
            return
        }
        $scope.processing = true
        const availabilityDate = ($scope.availability.date) ? $scope.availability.date : moment($scope.availability.dateObject).format('YYYY-MM-DD')
        const payload = {
            origin: $scope.order.origin,
            acceleratedProcedure: $scope.order.acceleratedProcedure,
            availability: {
                date: availabilityDate,
                slot: $scope.availability.slot,
            },
            reason: $scope.reason,
            bypassServiceOrder: $scope.order.bypassServiceOrder,
            isKnownSuccessor: $scope.order.isKnownSuccessor,
            isCustomerInformed: $scope.order.isCustomerInformed,
        }
        if ($scope.isC2C4) {
            payload.availability.hour = `${$scope.availability.hourOnly}:${$scope.availability.minute}:00`
        }
        if ($scope.comments) {
            payload.comments = $scope.comments
        }
        if (!updateContact(payload)) {
            $scope.processing = false
            return
        }
        const contractInfo = {
            idAccount: contract.id_account,
            idContract: contract.id,
            force: ($scope.order.readingMode === 'force'),
            doNotSendReadings: ($scope.order.readingMode === 'doNotSendReadings' || $scope.isCommunicatingLinky),
        }

        if ($scope.order.readingMode === 'readings') {
            payload.readings = $scope.order.readings
        }

        return ApiUser.terminateContract(contractInfo, payload)
        .$promise.then((result) => {
            if (result && result.success) {
                let message = 'Résiliation demandée'
                if (!pro) {
                    message += ' + mail envoyé'
                }
                AlertManager.success(message)
                $scope.ok()
            } else if (result.intervention_needed && result.timeTable) {
                $scope.availableSlots = result.timeTable
                $scope.availability = {
                    slot: $scope.availableSlots[0].code,
                    date: $scope.availableSlots[0].date,
                }
                return parseAvailableSlots($scope.availableSlots)
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.askTermination = function () {
        if ($scope.processing) {
            return
        }
        $scope.processing = true
        const availabilityDate = ($scope.availability.date) ? $scope.availability.date : moment($scope.availability.dateObject).format('YYYY-MM-DD')
        const payload = {
            origin: $scope.order.origin,
            acceleratedProcedure: $scope.order.acceleratedProcedure,
            availability: {
                date: availabilityDate,
            },
            reason: $scope.reason,
            bypassServiceOrder: $scope.order.bypassServiceOrder,
        }
        if ($scope.isC2C4) {
            payload.availability.hour = `${$scope.availability.hourOnly}:${$scope.availability.minute}:00`
            payload.isKnownSuccessor = $scope.order.isKnownSuccessor
            payload.isCustomerInformed = $scope.order.isCustomerInformed
        }
        if ($scope.comments) {
            payload.comments = $scope.comments
        }
        if (!updateContact(payload)) {
            $scope.processing = false
            return
        }
        const contractInfo = {
            idAccount: contract.id_account,
            idContract: contract.id,
            force: ($scope.order.readingMode === 'force'),
        }

        return ApiUser.askContractTermination(contractInfo, payload)
        .$promise.then((result) => {
            if (result && result.message === 'success') {
                AlertManager.success(`Demande de dépose effectuée`)
                $scope.ok()
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.suspend = function () {
        if ($scope.processing) {
            return
        }
        $scope.processing = true
        const payload = {
            sendOverdueValue: !!$scope.sendOverdueValue,
        }
        updateContact(payload)
        return ApiUser.suspendContract({ idContract: contract.id }, payload).$promise.then(() => {
            AlertManager.success('Coupure demandée')
            return $scope.ok() }).catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.reduce = function () {
        if ($scope.processing) {
            return
        }
        $scope.processing = true
        const payload = {
            sendOverdueValue: !!$scope.sendOverdueValue,
            date: ($scope.availability.date) ? $scope.availability.date : moment($scope.availability.dateObject).format('YYYY-MM-DD'),
        }
        updateContact(payload)
        return ApiUser.reduceContract({ idContract: contract.id }, payload).$promise.then(() => {
            AlertManager.success('Limitation demandée')
            return $scope.ok() }).catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.restore = function () {
        if ($scope.processing) {
            return
        }
        $scope.processing = true
        const payload = {
            urgent: $scope.order.urgent,
        }
        updateContact(payload)
        return ApiUser.restoreContract({ idContract: contract.id }, payload).$promise.then(() => {
            AlertManager.success('Restauration post-limitation demandée')
            return $scope.ok() }).catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.reactivate = function () {
        if ($scope.processing) {
            return
        }
        $scope.processing = true
        const payload = {
            urgent: $scope.order.urgent,
        }
        updateContact(payload)
        return ApiUser.reactivateContract({ idContract: contract.id }, payload).$promise.then(() => {
            AlertManager.success('Restauration post-coupure demandée')
            return $scope.ok() }).catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.isFormValid = () => {
        if ($scope.selectedAction === 'terminateFromClient') {
            const areC2C4SpecificFieldValids = !$scope.isC2C4 || ($scope.order.isKnownSuccessor !== null && $scope.order.isCustomerInformed !== null)
            return areC2C4SpecificFieldValids && ($scope.order.readingMode !== 'readings' || $scope.validations.value) && $scope.reason.choice && ($scope.reason.choice !== 'OTHER' || $scope.reason.text) &&
                (!$scope.showRequester() || ($scope.order.bypassServiceOrder && !$scope.isAskRemovalChoice) ||
                ($scope.requester.requester_civ && $scope.requester.requester_givenname && $scope.requester.requester_sn &&
                (!$scope.isAskRemovalChoice || $scope.requester.requester_phone || $scope.requester.requester_email)
                )) && ($scope.reason.choice !== 'REMOVAL' || ($scope.handmadeRemovalCaseID && $scope.handmadeRemovalCaseID.length >= 3))
        }
        return true
    }

    $scope.reinitialiseReadings = () => {
        $scope.order.readings = _.clone(initialReadings)
        $scope.validations = {}
    }

    $scope.validateReadings = () => {
        if (!$scope.checkReadingForTermination) {
            $scope.validations = { value: true }
        }
        if ($scope.order.readings.base) {
            if (_.isEmpty($scope.order.readings.base)) {
                $scope.validations = { value: false }
            }
            return ApiUser.checkReadings({ id_prm: contract.prm.id }, { base: $scope.order.readings.base }).$promise.then((result) => {
                $scope.validations = _.assign({}, result, { value: ['IGNORE', 'OK', 'WARNING'].indexOf(result.status) > -1 })
            }).catch((error) => {
                ErrorCatcher(error)
                $scope.validations = { value: false, error }
            })
        } else if ($scope.order.readings.hp && $scope.order.readings.hc) {
            if (_.isEmpty($scope.order.readings.hp) || _.isEmpty($scope.order.readings.hc)) {
                $scope.validations = { value: false }
            }
            return ApiUser.checkReadings({ id_prm: contract.prm.id }, { hp: $scope.order.readings.hp, hc: $scope.order.readings.hc }).$promise.then((result) => {
                $scope.validations = _.assign({}, result, { value: ['IGNORE', 'OK', 'WARNING'].indexOf(result.status) > -1 })
            }).catch((error) => {
                ErrorCatcher(error)
                $scope.validations = { value: false, error }
            })
        }
    }
    $scope.go = () => $scope[$scope.mode]()

    // RETURN OK
    $scope.ok = () => {
        if ($scope.reason.choice === 'ASK_REMOVAL') {
            const requester = _.pick($scope.requester, ['requester_civ', 'requester_sn', 'requester_givenname', 'requester_phone', 'requester_email'])
            const serviceOrdersContact = `demandeur et contact ordre de service : ${requester.requester_civ} ${requester.requester_sn} ${requester.requester_givenname}, `
                + `tel : ${requester.requester_phone} et email : ${requester.requester_email}`
            const removalContact = `contact technique dépose : ${$scope.contact.civ} ${$scope.contact.sn} ${$scope.contact.givenname} `
                + `tel : ${$scope.contact.phone}`
            const hour = $scope.isC2C4 ? ` à ${$scope.availability.hourOnly}:${$scope.availability.minute}:00` : ``
            AdminComments.addComment({ object: $scope.idContract,
                comment: `a créé une demande de relève pour le service client : ${serviceOrdersContact},`
                    + `date souhaitée ${moment($scope.availability.dateObject).format('YYYY-MM-DD')}${hour}, ${removalContact}`
                    + `${$scope.isC2C4 ? `, Successeur connu : ${$scope.order.isKnownSuccessor}, Client informé : ${$scope.order.isCustomerInformed}` : ``}`,
            })
            .$promise.catch(ErrorCatcher)
        } else {
            const handmadeRemovalCaseIDAppendice = $scope.handmadeRemovalCaseID ? `, id affaire dépose : ${$scope.handmadeRemovalCaseID}` : ''
            AdminComments.addComment({ object: $scope.idContract, comment: `a demandé une <b>${$scope.getAction()}</b> ${handmadeRemovalCaseIDAppendice}` }).$promise.catch(ErrorCatcher)
        }
        $uibModalInstance.close()
    }

    $scope.close = () => $uibModalInstance.dismiss()
})
